import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { FlexPassItemKind } from '@enums';
export function countFlexPassBaseMatchPicks(selected, items) {
  var n = 0;

  var _iterator = _createForOfIteratorHelper(selected),
      _step;

  try {
    var _loop = function _loop() {
      var id = _step.value;
      var it = items.find(function (i) {
        return i.childEventSessionId === id;
      });

      if ((it === null || it === void 0 ? void 0 : it.kind) === FlexPassItemKind.BASE_MATCH) {
        n += 1;
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return n;
}
/** Снимает выбор с элементов, для которых не выполнено unlockAtBasePicks по числу BASE_MATCH. */

export function pruneFlexPassUnlockPicks(selected, items) {
  var next = new Set(selected);
  var changed = true;

  while (changed) {
    changed = false;
    var base = countFlexPassBaseMatchPicks(next, items);

    var _loop2 = function _loop2() {
      var id = _arr[_i];
      var it = items.find(function (i) {
        return i.childEventSessionId === id;
      });
      if (!it) return "continue";
      var need = Number(it.unlockAtBasePicks) || 0;

      if (need > 0 && base < need) {
        next["delete"](id);
        changed = true;
      }
    };

    for (var _i = 0, _arr = _toConsumableArray(next); _i < _arr.length; _i++) {
      var _ret = _loop2();

      if (_ret === "continue") continue;
    }
  }

  return next;
}